<script>
  import { mapGetters } from 'vuex'
  import ListView from '../base/ListView.vue'

  export default {
    components: {
      ListView,
    },
    computed: {
      ...mapGetters({
        company: 'user/list/references/companies/item',
      })
    }
  }
</script>
<template>
  <list-view store="user" add-route="UserCreate" edit-route="UserUpdate">
    <template v-slot:header="slotProps">
      <b-col md="2"><strong>{{ $t('user.username.label') }}</strong></b-col>
      <b-col md="2"><strong>{{ $t('user.name.label') }}</strong></b-col>
      <b-col md="2"><strong>{{ $t('user.email.label') }}</strong></b-col>
      <b-col md="2"><strong>{{ $t('user.roles.label') }}</strong></b-col>
      <b-col md="2"><strong>{{ $t('user.companies.label') }}</strong></b-col>
      <b-col md="2"></b-col>
    </template>
    <template v-slot:item="slotProps">
      <b-col md="2">{{ slotProps.item.username }}</b-col>
      <b-col md="2">{{ slotProps.item.name }}</b-col>
      <b-col md="2">{{ slotProps.item.email }}</b-col>
      <b-col md="2">{{ slotProps.item.roles }}</b-col>
      <b-col md="2">
        <ul class="mb-0">
          <li v-for="companyId in slotProps.item.companies">
            {{ company(companyId).name}}
          </li>
        </ul>
      </b-col>
    </template>
  </list-view>
</template>
